import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OrderService } from 'src/app/services/order/order.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { deleteModalComponent } from 'src/app/components/deleteModal/deleteModal.component';
import { AddEnduserComponent } from '../add-enduser/add-enduser.component';
import { AddAddressComponent } from '../add-address/add-address.component';
import { AddPatientComponent } from '../add-patient/add-patient.component';
// import { AddAddressComponent } from "../pages/orders/order-create/add-address/add-address.component";
// import { AddEnduserComponent } from "../pages/orders/order-create/add-enduser/add-enduser.component";
// import { AddPatientComponent } from "../pages/orders/order-create/add-patient/add-patient.component";


@Component({
  selector: 'app-post-order',
  templateUrl: './post-order.component.html',
  styleUrls: ['./post-order.component.scss']
})
export class PostOrderComponent implements OnInit {
    constructor(
        private formBuilder: FormBuilder,
        private OrderService: OrderService,
        private toastr: ToastrService,
        public datepipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private http: HttpClient,
        private route: ActivatedRoute,

    ) { }
    get orderInfo() { return this.form.controls; }
    get testInfo() { return this.testform.controls; }
    today = new Date();

    form!: FormGroup
    testform!: FormGroup
    service: any = {
        page: 1,
        pageSize: 4,
        maxSize: 5
    };

    public searchNumberLoader = false;
    public isTestBtnLoaded = false;
    public applyCouponLoader = false;
    public createOrderLoaded = false;
    public date_slot=null;
    public secretId=null;

    public insuranceAvailable = false;
    public userdetails=undefined;
    public user_detail: any;
    public is_facility: any;
    public role_id: any;
    public allAddressList: any;
    public allPatientList: any;
    public allBookingList: any;

    // dropdown
    public slotlistForDropdown: any;
    public payerListForDropdown: any;
    public testlistForDropdown: any;
    public dateInputFormat: any;
    public currency: any;
    public selectedFile: File | null = null;
    public selectedFileName: string | null = null;
    specialInstruction = '';
    maxCharacters = 120;
    remainingCharacters: number = this.maxCharacters;
    customer_id: string;
    multiDropdownSettings: IDropdownSettings = {
        singleSelection: false,
        idField: 'value',
        textField: 'text',
        // selectAllText: 'Select All',
        // unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1 ,
        allowSearchFilter: true
    };

    user_id: any;
    total_amount: any = 0;
    amount_to_be_paid: any = 0;
    discount_item: any;
    copunCode: any;
    code = '';
    coupon_details: any;
    amount: any = 0;
    tax_amount: any = 0;
    final_amount: any =0;

    payerName: any;

    updateCharacterCount(): void {
      this.remainingCharacters = this.maxCharacters - this.specialInstruction.length;
    }

    ngOnInit() {



        this.route.paramMap.subscribe(params => {

            if (params.get('secretID')) {
              const secretID = atob(params.get('secretID'));

              this.customer_id = secretID;
          }
        });
        const userData = localStorage.getItem('user');
        if(userData){
            this.user_detail = JSON.parse(userData);
            this.is_facility = this.user_detail?.is_facility
        }else{
            this.is_facility = 0;
        }


        this.initializeForm();
        this.checkFacilityValidation();
        // console.log(this.is_facility);

        const today = new Date();
       // this.dateInputFormat = localStorage.getItem('dateFormat').toUpperCase();
        // this.currency = localStorage.getItem('currency');

        this.testform = this.formBuilder.group({
            patient: ['', Validators.required],
            test: ['', Validators.required],
            insuranceAvailable: ['', Validators.required],
            payerId: [''],
            insuranceId: ['']
        });
        this.OrderService.getPayerList().subscribe((data) => {
            this.payerListForDropdown = data.data;
        });
        this.testform.get('insuranceAvailable').valueChanges.subscribe(value => {
            this.insuranceAvailable = value === 'yes';
        });
    }
    onInsuranceChange(isAvailable: boolean) {
        this.insuranceAvailable = isAvailable;
    }
    initializeForm() {
        if(this.date_slot)
            {
        this.form = this.formBuilder.group({
            address: [''],  // Initially optional, will be conditionally required
            date: ['', Validators.required],
            slot: ['', Validators.required],
            scheduled_time: [''],
            booking_number: [],
            amount: [],
            tax_amount:  [],
            final_amount:  [],
            is_facility: [''] ,
            room_no: ['']
            // specialInstruction: ['']
        });
    }else
    {
        this.form = this.formBuilder.group({
            address: [''],  // Initially optional, will be conditionally required
            date: [new Date(), Validators.required],
            slot: ['', Validators.required],
            scheduled_time: [''],
            booking_number: [],
            amount: [],
            tax_amount:  [],
            final_amount:  [],
            is_facility: [''] ,
            room_no: ['']
            // specialInstruction: ['']
        });

    }


        /*this.testform = this.formBuilder.group({
            patient: ['', Validators.required],
            test: ['', Validators.required]
            is_facility: [''] ,
            room_no: ['']
        });*/

        // Listen for changes in is_facility field and update validation dynamically
        this.form.get('is_facility')?.valueChanges.subscribe(() => {
            this.checkFacilityValidation();
        });

    }

    checkFacilityValidation() {
        if (this.is_facility === 0) {
            this.form.get('address')?.setValidators(Validators.required);
        } else {
            this.form.get('address')?.clearValidators();
        }
        this.form.get('address')?.updateValueAndValidity();
    }
    searchNumber(data: any) {
        if (data.length > 6 ||data.length < 15) {
            this.searchNumberLoader = true;
            this.OrderService.searchNumberBycustomer({ phone: data,customer_id:this.customer_id }).subscribe(
                (res: any) => {
                    if (res.success) {
                        this.userdetails = res.data.data;
                        this.user_id = res.data.data.id;
                        this.allAddressList = res.data.address
                        this.allPatientList = res.data.patient
                        // this.toastr.success(`Phone valid`);
                       if(this.date_slot){
                        const datstring  = new Date(this.date_slot)
                        this.form.patchValue({
                            date: datstring // Formats to YYYY-MM-DD
                        });
                        const timestring = new Date(this.date_slot).toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          });
                        this.form.patchValue({
                            slot: timestring // Formats to YYYY-MM-DD
                        });
                    }
                    } else {
                        this.userdetails = undefined
                        if (res.message) {
                            this.toastr.error(`${res.message}`);
                        } else {
                            this.toastr.error(`Customer does not exist`);
                        }
                    }
                    this.searchNumberLoader = false;
                    this.refreshBookings();
                }),
                (err: any) => {
                    this.userdetails = undefined
                    if (err.message) {
                        this.toastr.error(`${err.message}`);
                    } else {
                        this.toastr.error(`Customer does not exist`);
                    }
                    this.searchNumberLoader = false;
                };
        } else {

            this.toastr.error(`Please Enter Valid Number`);
        }
    }

    getAllSlot() {


        // if (this.form.value.address != '') {
                this.getTest(this.form.value.address);
            if (this.form.value.date) {
                if (typeof (this.form.value.date) == 'object') {
                    this.form.value.date = this.datepipe.transform(this.form.value.date, 'YYYY-MM-dd HH:MM:ss')
                }

                this.slotlistForDropdown = [];
                this.OrderService.getallSlotCustomer(this.form.value,this.customer_id).subscribe((data) => {
                    if (data?.data?.time_slot) {
                        this.slotlistForDropdown = data.data?.time_slot;
                    }
                    if (data.message) {
                        // this.toastr.success(`${data.message}`);
                    } else {
                        if (data.error) {
                            this.toastr.error(data.error);
                        } else {
                            // this.toastr.success(`Slot Found`);
                        }
                    }

                }, (err) => {
                    if (err.message) {
                        this.toastr.error(`${err.message}`);
                    } else {
                        this.toastr.error(`not Found`);
                    }
                });

                this.form.value.slot='11:00AM';
            }

        // } else {
        //     this.toastr.success(`Please Select Address first`);
        // }
    }

    getTest(address_id) {
        this.OrderService.getallTestsCusertomer(address_id,this.customer_id).subscribe((data) => {
            if (data.message) {
                // this.toastr.success(`${data.message}`);
                const thisData = [];
                data?.data?.all_test.forEach(item => {
                    thisData.push(
                        { value: item.id, text: `${item.test_name} - ${item.test_code ? item.test_code : ''}` }
                    )
                });
                this.testlistForDropdown = thisData
            } else {
                if (data.error) {
                    this.toastr.error(data.error);
                } else {
                    // this.toastr.success(`Slot Found`);
                }
            }





        });
    }


    resetTestForm() {
        this.testform.get('patient').setValue('');
        this.testform.get('test').setValue('');
        this.testform.get('insuranceAvailable').setValue('no');
        this.testform.get('payerId').setValue('');
        this.testform.get('insuranceId').setValue('');
        this.insuranceAvailable = false;
        this.testform.markAsUntouched();
    }

    onAddTest(): void {
        this.testform.markAllAsTouched();
        if (this.testform.invalid) {
            return;
        }
        if (this.testform.valid) {
            this.isTestBtnLoaded = true

            const test_ids = this.testform.value.test && this.testform.value.test.length > 0 && this.testform.value.test.map((item: any) => item.value)

            const testform = {
                user_id: this.user_id,
                patient_id: this.testform.value.patient,
                test_ids: test_ids,
                insurance_available: this.testform.value.insuranceAvailable,
                customer_id: this.customer_id,

            } as any;
            if (this.testform.value.insuranceAvailable === 'yes') {
                testform.payer_id = this.testform.value.payerId;
                testform.insurance_id = this.testform.value.insuranceId;
            }
            // console.log(testform); return;

            this.OrderService.addTestWeb(testform).subscribe(
                (res: any) => {
                    this.resetTestForm();
                    this.refreshBookings();
                    if (res.message) {
                        // this.toastr.success(res.message);
                    }
                },
                (err: any) => {
                    this.toastr.error(`${err}`);
                },
                () => {
                    this.isTestBtnLoaded = false;
                }
            );
        }
    }
    onPatientChange(patientId: string) {
        if (!patientId) {
            // Reset form values if no patient selected
            this.testform.patchValue({
                insuranceAvailable: '',
                payerId: '',
                insuranceId: ''
            });
            this.insuranceAvailable = false;
            return;
        }

        // Call API to check if patient has existing insurance
        this.OrderService.getPatientInsurance(patientId).subscribe(
            (res: any) => {
                if (res && res.data.insurance_available === 'yes') {
                    // Set form values if insurance exists
                    this.testform.patchValue({
                        insuranceAvailable: 'yes',
                        payerId: res.data.payer_id,
                        insuranceId: res.data.insurance_id
                    });
                    this.insuranceAvailable = true;  // Show insurance fields
                } else {
                    // Reset values if no insurance found
                    this.testform.patchValue({
                        insuranceAvailable: 'no',
                        payerId: '',
                        insuranceId: ''
                    });
                    this.insuranceAvailable = false;
                }
            },
            (err: any) => {
                console.error('Error fetching patient insurance:', err);
                this.toastr.error('Failed to fetch insurance details.');
                this.insuranceAvailable = false;
            }
        );
    }
    refreshBookings() {
        if (this.user_id) {
            this.OrderService.getallBookingsWeb(this.user_id,this.customer_id).subscribe((data) => {
                // if (data?.data?.cart_list) {
                    this.allBookingList = data.data?.cart_list;
                // }
                this.total_amount = data.data?.total_amount;
                this.amount_to_be_paid = data.data?.total_amount;
            });
        }
    }

    removebookItem(item) {
        if (this.user_id) {
            this.OrderService.removeBookingItem(this.user_id, item.cart_id).subscribe((res) => {
                if (res.success) {
                    this.toastr.success(res.message);
                } else {
                    this.toastr.error(`${res.message}`);
                }
                this.refreshBookings();
            });
        }
    }


    removebookItemByPatient(item) {
        if (this.user_id && item.patient_id) {
            this.OrderService.removeBookingItemByPatient(this.user_id, item.patient_id).subscribe((res) => {
                if (res.success) {
                    this.toastr.success(res.message);
                } else {
                    this.toastr.error(`${res.message}`);
                }
                this.refreshBookings();
            });
        }
    }


    applyCoupon(data: any) {
        this.code = '';
        if (data) {
            this.applyCouponLoader = true;
            this.OrderService.applyCoupon(data).subscribe(
                (res: any) => {
                    if (res.success) {
                        this.toastr.success(res.message);
                        this.coupon_details = res?.data?.coupon_details
                        this.calculate_discount_amount();
                    } else {
                        if (res.message) {
                            this.toastr.error(`${res.message}`);
                        } else {
                            this.toastr.error(`${res.error}`);
                        }
                        this.coupon_details = undefined
                    }
                    this.copunCode = data;
                    this.applyCouponLoader = false;
                }),
                (err: any) => {
                    if (err.message) {
                        this.toastr.error(`${err.message}`);
                    } else {
                        this.toastr.error(`${err.error}`);
                    }
                    this.applyCouponLoader = false;
                    this.coupon_details = undefined
                    this.calculate_discount_amount();
                };
        } else {
            this.toastr.error(`Please Enter Valid Coupon Code`);
        }
    }

    calculate_discount_amount() {
        if (this.coupon_details) {
            if (this.coupon_details.coupon_value > this.total_amount) {
                this.amount_to_be_paid = 0;
            } else {
                if (this.coupon_details.coupon_type === 'flat_amount') {
                    this.amount_to_be_paid = (this.total_amount - this.coupon_details.coupon_value);
                } else {
                    this.amount_to_be_paid = this.total_amount - ((this.coupon_details.coupon_value / this.total_amount) * 100);
                }
            }
            this.discount_item = this.coupon_details.coupon_value
        }else{
            this.discount_item = undefined
            this.amount_to_be_paid = this.total_amount;
        }
    }

    createOrder() {

        this.form.markAllAsTouched();
        // console.log(this.specialInstruction); return;
        if (this.form.invalid) {
            return;
        }
        if (this.form.valid) {
            this.createOrderLoaded = true
            if (typeof (this.form.value.date) == 'object') {
                this.form.value.date = this.datepipe.transform(this.form.value.date, 'YYYY-MM-dd HH:MM:ss')
            }

            const formData = new FormData();

            // Append non-file fields
            formData.append('is_customer', '0');
            formData.append('user_id', this.user_id);
            // formData.append('address_id', this.form.value.address);
            formData.append('is_facility', this.is_facility);
            formData.append('date', this.form.value.date);
            formData.append('slot', this.form.value.slot);
            formData.append('coupon_code', this.copunCode || '');
            formData.append('user_type', 'admin');
            formData.append('special_instruction', this.specialInstruction || '');
            formData.append('scheduled_time', this.form.value.scheduled_time || '');
            formData.append('amount', this.amount || 0);
            formData.append('tax_amount', this.tax_amount || 0);
            formData.append('final_amount', this.final_amount || 0);
            formData.append('customer_id', this.customer_id);

            if (this.is_facility == '0') {
                formData.append('address_id', this.form.value.address);
            } else {
                formData.append('room_no', this.form.value.room_no || '');
            }
            // if (this.form.value.role_id === 32) {
            //     formData.append('room_no', this.form.value.room_no || '');
            // } else {
            //     formData.append('address_id', this.form.value.address);
            // }

            // Append the file, if selected
            if (this.selectedFile) {
                formData.append('lab_requisition_form', this.selectedFile);
            }

            // let payload = {
            //     "is_customer": 0,
            //     "user_id": this.user_id,
            //     "address_id": this.form.value.address,
            //     "date": this.form.value.date,
            //     "slot": this.form.value.slot,
            //     "coupon_code": this.copunCode,
              //  "user_type":"admin",
            // "amount": this.form.value.amount ,
              //  "tax_amount": this.form.value.tax_amount,
                // "final_amount": this.form.value.final_amount,
             // }
       //  console.log(formData); return;
            //     "user_type":"admin",
            //     "special_instruction": this.specialInstruction || '' ,
            //     "lab_requisition_form": this.selectedFile || '' ,
            //     "scheduled_time": this.form.value.scheduled_time,
            // }
            // console.log(this.is_facility); return;

            this.OrderService.createOrder(formData).subscribe(
                (res: any) => {

                    this.updateOrder(res.data.order_id);
                    this.form.reset();
                    if (res.message) {
                         this.toastr.success(res.message);
                    }
                },
                (err: any) => {
                    this.toastr.error(`${err}`);
                    this.createOrderLoaded = false;
                }
            );
        }

    }

    updateOrder(id){
        const payload = {
            order_id: id,
            payment_type:'Postpaid',
        }
        this.OrderService.updateOrderData(payload).subscribe(
            (res: any) => {
              this.OrderService.updateAssignLab(id).subscribe();
              this.router.navigateByUrl('order-public-view-submit/'+res.data.order_number);
              if (res.message) {
                    this.toastr.success('Order created successfully');
                }
            },
            (err: any) => {
                this.toastr.error(`${err}`);
            },
            () => {
                this.createOrderLoaded = false;
            }
        );
    }

    removeCopun(){
        this.discount_item = undefined
        this.amount_to_be_paid = this.total_amount;
        this.copunCode = undefined
    }


    addCustomer(){
            const modalRef = this.modalService.open(AddEnduserComponent, {
                centered: true,
                size: 'xl',
            });
            modalRef.componentInstance.props = {
                title: 'Add new Address',
                type: 'add',
                customer_id: this.customer_id,
                page: `page=${this.service.page}`,
            };
            modalRef.componentInstance.passEntry.subscribe((res: any) => {
            })
    }


    addAddress(data:any){
        const modalRef = this.modalService.open(AddAddressComponent, {
            centered: true,
            size: 'lg',
        });
        modalRef.componentInstance.props = {
            title: 'Add new Address',
            type: 'add',
            data: data.id,
            page: `page=${this.service.page}`,
        };
        modalRef.componentInstance.passEntry.subscribe((res: any) => {
            this.searchNumber(data.phone);
        })
    }

    editAddress(data,user){
        const dataSet = {data,id:user.id};
        const modalRef = this.modalService.open(AddAddressComponent, {
            centered: true,
            size: 'lg',
        });
        modalRef.componentInstance.props = {
            title: 'Edit Address',
            type: 'edit',
            data: dataSet,
            page: `page=${this.service.page}`,
        };
        modalRef.componentInstance.passEntry.subscribe((res: any) => {
            this.searchNumber(user.phone);
        })
    }

    addPatient(data:any){
        const modalRef = this.modalService.open(AddPatientComponent, {
            centered: true,
            size: 'xl',
        });
        modalRef.componentInstance.props = {
            title: 'Add new Patient',
            type: 'add',
            data: data.id,
            page: `page=${this.service.page}`,
        };
        modalRef.componentInstance.passEntry.subscribe((res: any) => {
            this.searchNumber(data.phone);
        })
    }

    editPatient(data,user){
        const dataSet = {data,id:user.id};
        const modalRef = this.modalService.open(AddPatientComponent, {
            centered: true,
            size: 'xl',
        });
        modalRef.componentInstance.props = {
            title: 'Edit Patient',
            type: 'edit',
            data: dataSet,
            page: `page=${this.service.page}`,
        };
        modalRef.componentInstance.passEntry.subscribe((res: any) => {
            this.searchNumber(user.phone);
        })

    }

    deletepatient(data:any){

        const ids = [data.patient_id,this.userdetails.id];
        const modalRef = this.modalService.open(deleteModalComponent, {
            centered: true,
            size: 'sm',
            windowClass: 'alert-popup',
        });
        modalRef.componentInstance.props = {
            title: `Are you sure want to delete`,
            subTitle: data.first_name+' '+data.last_name,
            type: 'deletePatient',
            data: ids,
        };
        modalRef.componentInstance.passEntry.subscribe((res: any) => {
            this.searchNumber(this.userdetails.phone);
        });
    }


    deleteAddress(data:any){
        const ids = [data.address_id,this.userdetails.id];
        const modalRef = this.modalService.open(deleteModalComponent, {
            centered: true,
            size: 'sm',
            windowClass: 'alert-popup',
        });
        modalRef.componentInstance.props = {
            title: `Are you sure want to delete`,
            subTitle: data.address,
            type: 'deleteAddress',
            data: ids,
        };
        modalRef.componentInstance.passEntry.subscribe((res: any) => {
            this.searchNumber(this.userdetails.phone);
        });
    }

    onFileSelected(event: any) {
        const file: File = event.target.files[0];


        if (file) {
          this.selectedFile = file;
          this.selectedFileName = file.name;
        }
    }

    updateFinalAmount() {
        let taxData=null;

        if(this.amount=='')
        {
            this.final_amount =0;
            taxData=0;

        }else
        {
            if(this.tax_amount=='')
            {
                taxData=0;
            }else{
                taxData=this.tax_amount;

            }
        this.final_amount = parseInt(this.amount) + parseInt(taxData);
        }
      }
}
